import { useMutation, useQueryClient } from '@tanstack/react-query';
import bankAccountsApi from '@/features/dashboard/paymentConfig/api/bankAccountsApi.ts';
import { bankAccountsApiQueryKeys } from '@/features/dashboard/paymentConfig/api/bankAccountsApi.queryKeys.ts';
import { EditBankAccountFormData } from '@/features/dashboard/paymentConfig/schemas/bankAccountSchema.ts';
import { bankAccountMapper } from '@/features/dashboard/paymentConfig/types/BankAccountDto.mapper.ts';
import { toast } from 'sonner';

export default function useUpdateBankAccount(id: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: EditBankAccountFormData) =>
      bankAccountsApi.update(id, bankAccountMapper.fromEditFormToDto(data)),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: bankAccountsApiQueryKeys.all(),
      });
      toast.success('Konto bankowe zostało zaktualizowane');
    },
    onError: (error: Error) => {
      toast.error('Wystąpił błąd', {
        description:
          error.message ||
          'Wystąpił błąd podczas aktualizacji konta bankowego.',
      });
    },
  });
}
